import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import PrimeTable from "../../../components/PrimeTable";
import { useCallback, useEffect, useMemo, useState } from "react";
import appActions from '../../../appActions';
import SysApiLogFilterForm from "./SysApiLogFilterForm";
import { Button } from "primereact/button";

const SysApilogsList =()=>{

    let navigate= useNavigate();
    const dispatch=useDispatch();

    const apiLogList= useSelector ((state) => state.sysApilogs.apiLogList)
    //const apiLog= useSelector((state) => state.sysApilogs.apiLog)
    const filters = useSelector((state) => state.sysApilogs.filters);

    const defaultParams = useMemo(() => ({
        ...filters,
        pageno: 1,
        pagesize: 50,
        sort: 'createdOn',
        sortOrder: -1,
    }), [filters]);

    const [formValues, setFormValues] = useState(defaultParams)

    const handleFormValuesChange = (values) => {
        setFormValues(values);
    }

    const handleRefresh = useCallback(() => {
        dispatch(appActions.APILOGS_GET_ALL_REQUEST(defaultParams));
    }, [dispatch, defaultParams]);

    const renderHeader = () => {
        return (
            <div className="d-flex flex-row gap-10 align-items-center">
                <h1 className="page-header flex"> Visual Store Api Logs </h1>
                <Button icon="pi pi-sync" rounded text aria-label="Refresh" className='mr-auto tp' data-pr-tooltip="Refresh" onClick={handleRefresh} />
            </div>
        );
    };

    const handleReset = () => {
        setFormValues(defaultParams)
        dispatch(appActions.STOREITEMS_GET_ALL_REQUEST(defaultParams));
    }

    const handleSearch = useCallback(
        (params) => {
            const searchParams = {
                ...params,
                pagesize: params.pagesize || defaultParams?.pagesize,
                pageno: params.pageno || defaultParams?.pageno,
                sort: params.sort || defaultParams?.sort,
                sortOrder: params.sortOrder || defaultParams?.sortOrder,
            };
            dispatch(appActions.APILOGS_GET_ALL_REQUEST(searchParams));
        },
        [dispatch, defaultParams]
    );

    useEffect(() => {
        handleSearch(defaultParams);
    }, []); // Empty dependency array ensures it runs only on mount

    const handleViewRedirect = useCallback((record) => {
        const data = apiLogList?.data?.find(t => t.id === record.id);
        navigate('/ui/sys-apilogs/details', { state: { data, isView: true } });
    }, [apiLogList, navigate]);

    const actionTemplate = useCallback(
        (rowData) => (
            <div className="flex gap-10 justify-content-center">
                <span className="cursor-pointer tp" onClick={() => handleViewRedirect(rowData)} data-pr-tooltip="View">
                    <i className="pi pi-eye text-blue-500 text-base"></i>
                </span>
            </div>
        ),
        [handleViewRedirect],
    );

    const onFilterChangeCallback  = useCallback(
        (e) => {

            const { sortField, sortOrder, rows, page } = e;
            
            const params = {...formValues, pagesize: rows, pageno: page, sort: sortField, sortOrder: sortOrder };

            setFormValues(prevFormValues => ({
                ...prevFormValues,
                sort: sortField, 
                sortOrder: sortOrder,
                pagesize: rows,
                pageno: page
            }));

            handleSearch(params); // Call search with updated sorting params
        },
        [handleSearch, formValues],
    );
    
    const columns = [       
        { field: 'fileId', header: 'File Id', sortable: true, fileLog: true, width: '110px'},
        { field: 'urlText', header: 'API URL', sortable: true, fileLog: true },
        { field: 'requestText', header: 'Request Text', sortable: true, fileLog: true},
        { field: 'responseText', header: 'Response Text', sortable: true, fileLog: true},
        // { field: 'hostIp', header: 'Host IP', sortable: true, width: '130px' },
        { field: 'responseStatus', header: 'Response Status', sortable: true, width: '150px'},
        // { field: 'processTime', header: 'Process Time', sortable: true, width: '130px'},
        // { field: 'status', header: 'Status', sortable: true, width: '100px'},       
        { field: 'createdOn', header: 'Created On', sortable: true, width: '140px', columnType: 'datetime' },    
        // { field: 'lastUpdated', header: 'Last Updated', sortable: true, columnType : 'datetime'  },
        // { field: 'lastUpdatedBy', header: 'Last Updated By', sortable: true },
    ];

    const renderList = () => {
        return (
            <>
                <div className='pv-15 ph-15'> {renderHeader()} </div>
                <div className="bg-white mx-3 pv-15 ph-15 br-6 shadow-white">
                    <SysApiLogFilterForm 
                        handleSearch={handleSearch} 
                        handleReset={handleReset}  
                        onFormValuesChange={handleFormValuesChange} 
                    />
                    <div className='custom-devider'></div>
                    <PrimeTable
                        list={apiLogList}
                        columns={columns}
                        actionColumn={actionTemplate}
                        onFilterChangeCallback={(e) => {
                            onFilterChangeCallback(e);
                        }}
                        tableName='api_logs'
                        isLazy={true}
                        showGenerateXmlBtn={false}
                    />
                </div>
            </>
        );
    };

    return <div className="form_height">{renderList()}</div>;

}

export default SysApilogsList;

